<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Agenda Search</li>
  </ul>
  
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Agenda Search</strong>
      </span>
      <span style="float:right">
        <!-- <button class="btn btn-sm btn-primary mb-2" type="button" data-toggle="modal" data-target="#companyDialog" (click)="">Add Meeting</button>
          -->
        <!-- <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button" (click)="initiateUploadAgendaDocs()">
          <i class="fa fa-plus"></i>Upload Agenda Template</button> -->
        <!-- <a [routerLink]="['/meeting/add']">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button" [appHasPermission]="{'Url': '/meeting/edit?goveva=true&email=', 'method':'put', 'menu': 'Meetings'}">
            <i class="fa fa-plus"></i>Add Meeting</button>
        </a> -->
      </span>
    </div>
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <form>
              <div class="row agenda-search-filter-row">
                <div class="col-md-3">
                  <label class="form-control-label">Meeting Type :</label>
                  <div class="form-group">
                    <select id="drpmeeting" [(ngModel)]="selectedMeeting" class="form-control" (ngModelChange)="getMeetingFromType()" [ngModelOptions]="{standalone:true}">
                      <option value=null [selected]="true">Select</option>
                      <option *ngFor="let meetingTypeList of meetingType" [ngValue]="meetingTypeList._id">{{meetingTypeList.MeetingType}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-control-label">Meetings Date Range:</label>
                  <div class="form-group">
                    <div class="input-group date-range-group-agenda">
                      <span class="date-range-label">From:&nbsp;</span>
                      <app-datepicker-material [(ngModel)]="meetingsSearchDateFrom" [placeholder]="'dd-mm-yyyy'"
                        (ngModelChange)="meetingDateSearchMeeting()" [ngModelOptions]="{standalone: true}">
                      </app-datepicker-material>
                      <span class="date-range-label">&nbsp;&nbsp;To:&nbsp;</span>
                      <app-datepicker-material [(ngModel)]="meetingsSearchDateTo" [placeholder]="'dd-mm-yyyy'"
                        [ngModelOptions]="{standalone: true}">
                      </app-datepicker-material>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="form-control-label">&nbsp;</label>
                  <div class="form-group filter-actions-agenda">
                    <button type="button" [disabled]="response" class="btn btn-sm btn-primary" (click)="advFilterSearch();">
                      <i class="fa fa-search"></i>&nbsp;Search</button>
                    <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear" (click)="clearAdvSearchResult()">
                      <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  
  
      <!-- START Agenda Multiple File Download View Dialoge -->
      
      <div class="modal fade modal-size-medium" id="AgendaSearchFileDialoge" tabindex="-1" role="dialog"
        data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="fa fa-download"></i>
                <span> Agenda Files</span>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <div class="row collapse1">
                  <span class="cat__core__title">
                    Files List
                  </span>
      
                  <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                    <thead>
                      <tr>
      
                        <th>Filename</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let agendafile of this.loadedAgendaFiles.loadedAgendaFilesArray; let count=index">
      
                        <td tabindex="1" style="cursor: move; width: 70%;">
                          {{agendafile.name}}
                        </td>
                        <td>
                          <button type="button" class="btn-sm btn btn-warning" (click)="downloadDoc(agendafile.docId)">
                            <span class="fa fa-download"></span>
                          </button>
                          
                          <button *ngIf="agendafile.name.includes('.pdf')" type="button" class="btn-sm btn btn-warning" (click)="openPdf(agendafile.docId,this.loadedAgendaFiles.meetingId, agendafile.name, 'pdf')">
                            <span class="fa fa-eye"></span>
                          </button>
                          
                          
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  
      
                </div>
              </div>
            </div>
      
          </div>
        </div>
      </div>
      <!-- END Agenda Multiple File Download View Dialoge -->
  
    <div class="card-block datatable-card-block">
      <!-- Search Filter Dropdown with Content Search Button -->
      <div class="row mb-3 align-items-end">
        <div class="col-md-3">
          <label class="form-control-label">Search Filter:</label>
          <select id="drpSearchFilter" [(ngModel)]="searchMode" class="form-control" (ngModelChange)="onSearchModeChange()" [ngModelOptions]="{standalone:true}">
            <option value="standard">Standard</option>
            <option value="content">Content based search</option>
          </select>
        </div>
        <div class="col-md-3" *ngIf="searchMode === 'content'">
          <button type="button" 
                  class="btn btn-primary btn-content-search" 
                  (click)="performContentBasedSearch()"
                  [disabled]="response">
            <i class="fa fa-search"></i> Search Content
          </button>
        </div>
      </div>
      
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <!-- <table id="datatableAgendaSearch" datatable [dtOptions]="dtOptions" class="table table-hover compact cell-border nowrap stripe">
              </table> -->
                    <table datatable [dtOptions]="dtMeetingList" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap stripe"
                id="agendaTable" style="cursor: pointer;">
                <thead>
                  <tr>
  
                    <th style="width:222px">Meeting Type </th>
                    <th style="width:230px" class="sorting">Meeting Date</th>
                    <th style="width:225px">Agenda Title</th>
                    <th style="width:225px">Agenda</th>
                    <th style="width:225px">Agenda Document</th>
                    <th style="width:225px">Final Minutes Document</th>
                   
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let agenda of meetingArray; let count=index" style="line-height: 25px;">
  
                    <td tabindex="1">{{agenda.MeetingTypeName}}</td>
                      <td tabindex="1" class="sorting">
                        <span style="display: none">{{agenda.MeetingDate | date : "yMMdd"}}</span>{{agenda.MeetingDate | date :
                        "dd-MM-y"}}</td>
                    <td tabindex="1"  style="white-space: normal !important;">{{agenda.AgendaTitle || agenda.agendaTitle}}</td>
                    <td style="width:20%"><label class="input-group">
                      <input data-toggle="tooltip" type="text"
                          [value]="(agenda.AgendaGenerationDocument && agenda.AgendaGenerationDocument.DocName) ? agenda.AgendaGenerationDocument.DocName : 'File Not Available'"
                          class="form-control" [disabled]="true">
  
                      <span
                          *ngIf="agenda.AgendaGenerationDocument && agenda.AgendaGenerationDocument.IsAvailable && agenda.AgendaGenerationDocument.DocName != 'File Not Available' && agenda.AgendaGenerationDocument.DocName != ''"
                          (click)="downloadAgendaDocs(agenda.meetingID, agenda._id, 'Agenda')"
                          class="input-group-addon default">
                          <i class="fa fa-download"></i>
                      </span>
                  </label></td>
                  <td style="width:20%"><label class="input-group">
                        <input data-toggle="tooltip" type="text"
                        [value]="agenda.Documents && agenda.Documents.agendaFileArray && agenda.Documents.agendaFileArray.length > 0  ? 
                              agenda.Documents.agendaFileArray.length +' File(s)' : (agenda.Documents && agenda.Documents.agendaFile && agenda.Documents.agendaFile.isAvaible) ? 
                              '1 File(s)' : 'File Not Available'"
                        class="form-control" [disabled]="true">
  
                        <span
                            *ngIf="(agenda.Documents.agendaFile && agenda.Documents.agendaFile.isAvaible 
                                  && agenda.Documents.agendaFile.name != 'File Not Available' && agenda.Documents.agendaFile.name != '') 
                                  || (agenda.Documents.agendaFileArray && agenda.Documents.agendaFileArray.length > 0) "
                            (click)="sycnAgendaFileandAgendaFileArrayAndOpenDownloadModal(agenda.meetingID)"
                            class="input-group-addon default">
                            <i class="fa fa-download"></i>
                        </span>
                        
                </label></td>
               
                    <td style="width:20%"><label class="input-group">
                      <input data-toggle="tooltip" type="text"
                          [value]="(agenda.Documents && agenda.Documents.finalFile && agenda.Documents.finalFile.name) ? agenda.Documents.finalFile.name : 'File Not Available'"
                          class="form-control" [disabled]="true">
    
                      <span
                          *ngIf="agenda.Documents.finalFile && agenda.Documents.finalFile.isAvaible && agenda.Documents.finalFile.name != 'File Not Available' && agenda.Documents.finalFile.name != ''"
                          (click)="downloadFile(agenda.Documents.finalFile.docId)"
                          class="input-group-addon default">
                          <i class="fa fa-download"></i>
                      </span>
                      <span
                      *ngIf="agenda.Documents.finalFile && agenda.Documents.finalFile.isAvaible && agenda.Documents.finalFile.name != 'File Not Available' && agenda.Documents.finalFile.name != ''"
                      (click)="openPdf(agenda.Documents.finalFile.docId,agenda.meetingID , agenda.Documents.finalFile.name, 'pdf')"
                      class="input-group-addon default">
                      <i class="fa fa-eye"></i>
                  </span>
                  </label></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- <app-pdfviewer *ngIf="fileUrl" [file]="fileUrl"></app-pdfviewer> --> 
  
  </section>
  <app-alert></app-alert>
  
  